// spinner.component.ts
import { Component } from '@angular/core';
import { LoaderService } from '@/app/services/interceptor/loader-service';
import { DesyAngularModule } from 'desy-angular';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-spinner',
  imports: [CommonModule, DesyAngularModule],
  templateUrl: './spinner.component.html',
  styles: [
    `
      .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
      }
    `,
  ],
})
export class SpinnerComponent {
  constructor(public loader: LoaderService) {}
}
